import {
  SESSION_ENDED_MESSAGE_KEY,
  SESSION_EXPIRED_MESSAGE,
  isTokenExpired,
} from "./sessionKeeper";

const INACTIVITY_LIMIT = 30 * 24 * 60 * 60 * 1000; // 30 days
// const INACTIVITY_LIMIT = 10 * 1000; // 10 seconds (For Testing)

const BRAND_ROLES = ["brand", "brand-admin", "brand-staff"];
const MEMBER_ROLES = ["influencer", "member"];

// Where a user with this stored role signs back in.
export const getSigninPath = (role) => {
  const normalizedRole = String(role || "").toLowerCase();
  if (BRAND_ROLES.includes(normalizedRole)) return "/brand/signin";
  if (MEMBER_ROLES.includes(normalizedRole)) return "/member/signin";
  return "/internal/signin";
};

const expireSession = () => {
  try {
    sessionStorage.setItem(SESSION_ENDED_MESSAGE_KEY, SESSION_EXPIRED_MESSAGE);
  } catch (err) {
    // Storage blocked - the user is still signed out, just without the notice.
  }
  localStorage.clear();
};

export const isSessionValid = () => {
  const token = localStorage.getItem("token");
  const role = localStorage.getItem("userRole");
  const lastActivity = Number(localStorage.getItem("lastActivity"));

  if (!token || !role) return false;

  // The backend rejects an expired token on every call, so the session is
  // over - end it with a message rather than leave a dashboard whose
  // requests all fail.
  if (isTokenExpired(token)) {
    expireSession();
    return false;
  }

  // Some sign-in paths (OTP signup, admin "log in as brand") don't record
  // lastActivity. A missing value means a session that just started, not an
  // idle one - clearing it here signed those users out on their first page.
  if (lastActivity && Date.now() - lastActivity > INACTIVITY_LIMIT) {
    expireSession();
    return false;
  }

  // sliding session
  localStorage.setItem("lastActivity", Date.now().toString());

  return true;
};
